import {LiveChatDataObject} from "../../events/ws";
import {useMemo} from "react";
import {useStateValue} from "../state-provider/StateProvider";

export const useLiveChat = (
  organizationId: string,
  referenceId: string
) => {

  const [{
    liveChats,
  }] = useStateValue()

  return useMemo(() => {
    return liveChats.find(
      (c: LiveChatDataObject) => c.referenceId === referenceId
    )
  }, [liveChats, organizationId, referenceId])
}

